import { createFileRoute } from "@tanstack/react-router";
import { SEOPage } from "@/components/site/SEOPage";

export const Route = createFileRoute("/politica-de-privacidade")({
  head: () => ({
    meta: [
      { title: "Política de Privacidade - P2 PRO | Segurança dos Seus Dados" },
      { name: "description", content: "Saiba como a P2 PRO protege seus dados pessoais e garante a sua privacidade. Conheça nossas diretrizes de segurança e tratamento de informações conforme a LGPD." },
    ],
  }),
  component: () => (
    <SEOPage
      category="Institucional"
      title="POLÍTICA DE PRIVACIDADE P2 PRO"
      subtitle="Sua segurança e a proteção de seus dados são nossas prioridades absolutas."
      introParagraphs={[
        "Na P2 PRO, entendemos que a privacidade é um direito fundamental de todos os nossos usuários e parceiros. Esta Política de Privacidade descreve como coletamos, utilizamos, armazenamos e protegemos suas informações pessoais quando você utiliza nosso site, nossos serviços ou nosso painel gerencial.",
        "Ao utilizar a infraestrutura da P2 PRO, você confia em nós com suas informações, e levamos essa responsabilidade muito a sério. Trabalhamos constantemente para manter os mais altos padrões de segurança cibernética e transparência no tratamento de dados.",
        "Nossas diretrizes estão totalmente alinhadas com a Lei Geral de Proteção de Dados (LGPD) e as melhores práticas internacionais de segurança da informação, garantindo que você tenha controle total sobre seus dados."
      ]}
      benefits={[
        {
          title: "Criptografia SSL",
          description: "Toda a navegação e troca de dados em nosso site e painel são protegidas por certificados de segurança avançados.",
        },
        {
          title: "Dados Anonimizados",
          description: "Utilizamos processos de anonimização para garantir que padrões de uso não sejam vinculados à sua identidade real.",
        },
        {
          title: "Transparência Total",
          description: "Informamos claramente quais dados são necessários e para qual finalidade específica eles serão utilizados.",
        }
      ]}
      howItWorks={[
        { title: "Coleta", description: "Coletamos apenas os dados essenciais para a prestação do serviço, como e-mail ou contato de WhatsApp." },
        { title: "Armazenamento", description: "Suas informações são guardadas em servidores seguros com acesso restrito e monitorado." },
        { title: "Uso", description: "Utilizamos os dados exclusivamente para suporte técnico, ativação de serviços e comunicações importantes." },
        { title: "Direitos", description: "Você pode solicitar a exclusão, correção ou acesso aos seus dados a qualquer momento." }
      ]}
      diferenciais={[
        { title: "LGPD Compliance", description: "Processos internos auditados para cumprir integralmente a legislação brasileira." },
        { title: "Zero Compartilhamento", description: "Nunca vendemos ou compartilhamos suas informações com terceiros para fins publicitários." },
        { title: "Segurança de Camada 7", description: "Proteção contra invasões e vazamentos em todos os níveis da nossa rede." }
      ]}
      faq={[
        {
          question: "Quais dados vocês coletam?",
          answer: "Apenas informações básicas de contato necessárias para a identificação da sua conta e prestação de suporte."
        },
        {
          question: "Como posso pedir a exclusão dos meus dados?",
          answer: "Basta entrar em contato com nosso time de atendimento que processaremos sua solicitação em até 24 horas úteis."
        },
        {
          question: "Vocês usam cookies?",
          answer: "Sim, utilizamos cookies técnicos para melhorar sua experiência de navegação e lembrar suas preferências de login."
        }
      ]}
      breadcrumbs={[
        { label: "Institucional", href: "/" },
        { label: "Privacidade", href: "/politica-de-privacidade" }
      ]}
    />
  ),
});
